/**
 *
 * @module deviceClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class DeviceClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the DeviceClient.
 *
 */
export default class DeviceClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/device/deviceClientConfiguration.js